import { render } from "./ObjectLogSection.vue?vue&type=template&id=cbd62b38&scoped=true"
import script from "./ObjectLogSection.vue?vue&type=script&lang=js"
export * from "./ObjectLogSection.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=cbd62b38&scoped=true&lang=css&external"
import "./ObjectLogSection.vue?vue&type=style&index=1&id=cbd62b38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd62b38"]])

export default __exports__